import {
  useRef,
  useState,
  useContext,
  useLayoutEffect,
  useEffect,
} from "react";
import Editoroptions from "../Editoroptions/Editoroptions";
import Toolbar from "../Toolbar/Toolbar";
import "./Visualeditor.scss";
import { useOutsideClick } from "../../Utils/UseOutsideClick";
import ChangeResumeOrder from "../../hooks/editor/changeResumeOrder";
import { useDispatch, useSelector } from "react-redux";
import { ResumeUpdateContext } from "../../Context/resumeUpdateContext";
import { RESUME_PREVIEW_RESET } from "../../Store/Constants/ResumeConstants";
import { userTypeContext } from "../../Context/FreeOrProContext";
import TemplateLoader from "../../TemplateGenerator/TemplateLoader/TemplateLoader";
import TemplateLoaderFull from "../../TemplateGenerator/TemplateLoader/TemplateLoaderFull";

function Visualeditor(props) {
  const dispatch = useDispatch();

  const { image, takeScreenShot, visualEditorFocus } =
    useContext(ResumeUpdateContext);

  const ref = useRef();
  const { userType, resumeCount } = useContext(userTypeContext);

  const [showOverlay, setShowOverlay] = useState(true);
  //   const loadCustomization = useSelector(
  //     (state) => state.editorData.customization.fonts
  //   );
  const editorData = useSelector((state) => state.editorData);

  function undo(e) {
    document.execCommand(e);
  }

  function redo(e) {
    document.execCommand(e);
  }

  const downloadAsWord = () => {
    var css;
    css = document.head.getElementsByTagName("style");
    var header =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
    var footer = "</body></html>";
    var sourceHTML = header + css + window.docx.innerHTML + footer;

    var source =
      "data:application/vnd.ms-word;charset=utf-8," +
      encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = "document.doc";
    fileDownload.click();
    document.body.removeChild(fileDownload);
  };

  // const { overflow, setOverflow } = ChangeResumeOrder();

  const getImage = () => (ref && ref ? takeScreenShot(ref.current) : "");

  //   const css = `
  // 	input::-webkit-input-placeholder {
  // 		font-size: ${
  //       loadCustomization &&
  //       loadCustomization.fontSize &&
  //       loadCustomization.fontSize.bodyFontSize
  //     };
  // 	}
  // 	[contenteditable][data-placeholder]:empty:before {
  // 		font-size:${
  //       loadCustomization &&
  //       loadCustomization.fontSize &&
  //       loadCustomization.fontSize.bodyFontSize
  //     };
  // 		background-color: transparent;
  // 	  }`;

  return (
    <>
      <div className=" m-0" style={props && props.sample && { height: "0px" }}>
        <div
          className="visualeditor"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
          }}
          ref={ref}
        >
          {/* <Toolbar
            undo={(e) => undo("undo")}
            redo={(e) => redo("redo")}
            download={downloadAsWord}
            setOverflow={setOverflow}
            shareShow={props.shareShow}
            setShowPreview={props.setShowPreview}
            setBlobUrl={props.setBlobUrl}
          /> */}
          <TemplateLoader
            resumeFields={props.resumeFields}
            resumeHandler={props.resumeHandler}
            resumeTitleHandler={props.resumeTitleHandler}
            resumeUpdate={props.resumeUpdate}
            sectionTitleUpdate={props.sectionTitleUpdate}
            handleEditorChange={props.handleEditorChange}
            dateHandler={props.dateHandler}
            languageHandler={props.languageHandler}
            addResumeField={props.addResumeField}
            showHideElements={props.showHideElements}
            sectionMoveUp={props.sectionMoveUp}
            sectionMoveDown={props.sectionMoveDown}
            deletePopupShow={props.deletePopupShow}
            sectionItemMoveUp={props.sectionItemMoveUp}
            sectionItemMoveDown={props.sectionItemMoveDown}
            handleItemDelete={props.handleItemDelete}
            showHideBackground={props.showHideBackground}
            contentAdder={props.contentAdder}
            setResumeFields={props.setResumeFields}
            visualEditorFocus={props.visualEditorFocus}
            setVisualEditorFocus={props.setVisualEditorFocus}
            previewModal={props.previewModal}
            sample={props.sample}
            preview={props.preview}
            isSplit={props.isSplit}
            pickTemplate={props.pickTemplate}
            handleSliderChange={props.handleSliderChange}
            handleEditor={props.handleEditor}
            skillsLevelHandler={props.skillsLevelHandler}
            handleBorderChange={props.handleBorderChange}
            handleProfileImageChange={props.handleProfileImageChange}
            setIsSample={props.setIsSample}
            changeIconSettings={props.changeIconSettings}
            handleAchievementSvg={props.handleAchievementSvg}
            handleItemIcon={props.handleItemIcon}
            skillsLevelHandlerRcSlider={props.skillsLevelHandlerRcSlider}
            handleLanguageSliderChange={props.handleLanguageSliderChange}
          />
        </div>
      </div>
    </>
  );
}

export default Visualeditor;
